import AdsPage from './list/AdsPage.vue';

const routes = [
  {
    path: '/ads',
    name: 'ads',
    component: AdsPage,
    meta: {
      title: 'Actualités',
      requiresAuth: true
    }
  }
];

export default routes;
